import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ComparePage } from '@/features/design/compare-page';

const searchSchema = z.object({
  drawing: z.string().optional().catch(undefined),
  a: z.string().optional().catch(undefined),
  b: z.string().optional().catch(undefined),
});

export const Route = createFileRoute('/_app/projects/$projectId/design/compare')({
  validateSearch: searchSchema,
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  const search = Route.useSearch();
  return <ComparePage projectId={projectId} drawingId={search.drawing} a={search.a} b={search.b} />;
}
